import {isIE} from "./html";

interface IStorageItem {
	handler: (e: Event) => any;
	scope: any;
}
interface IKeyStorage {
	[key: string]: IStorageItem[];
}

interface IKeyManager {
	addHotKey(key: string, handler, scope?: any): void;
	removeHotKey(key?: string, scope?: any): void;
	exist(key: string): boolean;
}


function getHotKeyCode(code: string): string {
	const matches = code.toLowerCase().match(/\w+/g);
	let comp = 0;
	let key = "";
	for (let i = 0; i < matches.length; i++) {
		const check = matches[i];
		if (check === "ctrl") {
			comp += 4;
		} else if (check === "shift") {
			comp += 2;
		} else if (check === "alt") {
			comp += 1;
		} else {
			key = check;
		}
	}
	return comp + key;
}

class KeyManager implements IKeyManager {
	private _keysStorage: IKeyStorage = {};

	constructor() {
		document.addEventListener("keydown", (e: KeyboardEvent) => {
			const comp = (e.ctrlKey || e.metaKey ? 4 : 0) + (e.shiftKey ? 2 : 0) + (e.altKey ? 1 : 0);
			let key;
			if ((e.which >= 48 && e.which <= 57) || (e.which >= 65 && e.which <= 90)) { // A-Z 0-9
				key = String.fromCharCode(e.which);
			} else {
				// dirty: added space binding
				if (e.which === 32 && !isIE()) {
					key = e.code;
				} else {
					key = e.key;
				}
			}

			const code = comp + (key && key.toLowerCase());
			const actions = this._keysStorage[code];

			if (actions) {
				for (let i = 0; i < actions.length; i++) {
					actions[i].handler(e);
				}
			}
		});
	}
	addHotKey(key: string, handler, scope?: any): void {
		const code = getHotKeyCode(key);
		if (!this._keysStorage[code]) {
			this._keysStorage[code] = [];
		}
		this._keysStorage[code].push({
			handler,
			scope
		});
	}
	removeHotKey(key?: string, scope?: any): void {
		const keyStorage = this._keysStorage;
		if (key) {
			const code = getHotKeyCode(key);
			delete keyStorage[code];
		}
		if (scope) {
			for (const code in keyStorage) {
				const toDelete = []; // items index to delete
				for (let i = 0; i < keyStorage[code].length; i++) {
					if (keyStorage[code][i].scope === scope) {
						toDelete.push(i);
					}
				}
				if (keyStorage[code].length === toDelete.length) {
					delete keyStorage[code];
				} else {
					for (let i = toDelete.length - 1; i >= 0; i--) { // begin from last coz splice change other index
						keyStorage[code].splice(toDelete[i], 1);
					}
				}
			}
		}
	}
	exist(key: string): boolean {
		const code = getHotKeyCode(key);
		return !!this._keysStorage[code];
	}
}

export const keyManager = new KeyManager();

export function addHotkeys(handlers, beforeCall?: () => boolean) {
	const context = new Date();

	const wrapHandler = handler => e => {
		if (beforeCall && beforeCall() === false) {
			return;
		}
		handler(e);
	};

	for (const key in handlers) {
		keyManager.addHotKey(
			key,
			wrapHandler(handlers[key]),
			context
		);
	}

	return () => keyManager.removeHotKey(undefined, context);
}